export const LOGOUT_REF = 'logout';
export const TAGS = {
    collections: 'collections',
    products: 'products',
    cart: 'cart',
};
export const REFERRAL_URL =
    process.env.INFLUENCE_BASE_REFERRAL_URL ?? 'https://r.infl.co/';
export const TEST_CUSTOMER_ID = process.env.TEST_CUSTOMER_ID ?? '8532878557507';
export const SHOP_KEY = process.env.INFLUENCE_SHOP_KEY ?? '';
export const BASE_SITE_URL =
    process.env.REDIRECT_BASE_SITE_URL ?? 'https://nutriburst.vercel.app';

export const BEST_SELLING_PRODUCTS = [
    'hair-skin-nails-sugar-free-vegan-gummies',
    'ashwagandha-ksm-66-sugar-free-vegan-gummies',
    'vitamin-d3-k2-sugar-free-vegan-gummies',
    'totalcare-plus-multivitamin',
    'optimum-c',
];
